<template>
  <topics-loader>
    <mc-app-header title="Topics">
      <template v-slot:left>
        <div class="level-item">
          <router-link
            class="button is-small is-primary is-outlined"
            to="/topics/new"
          >
            Add New
          </router-link>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="topics section">
        <mc-dnd-list
          v-if="topics.list.length > 0"
          container-class="mc-container"
          :list="topics.list"
          :on-drop="moveTopic"
          :sort-handler="sortHandler"
        >
          <template #item="{ item }">
            <topic-item :item="item" />
          </template>
        </mc-dnd-list>
        <div v-else class="box mc-container">
          <div class="content has-text-centered">
            No topics available!
          </div>
        </div>
      </div>
    </mc-app-body>
  </topics-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import sortBy from 'lodash/sortBy';

import TopicItem from './TopicItem';
import TopicsLoader from './TopicsLoader';

export default {
  computed: {
    ...mapState(['topics'])
  },
  methods: {
    ...mapActions('topics', ['moveTopic']),
    sortHandler: function(list) {
      return sortBy(list, ['serialNumber']);
    }
  },
  components: {
    TopicItem,
    TopicsLoader
  }
};
</script>
